import React from "react";
import { FormattedMessage } from "react-intl";

import { ReturnButton, StyledButton } from "./styles";

import { FiArrowLeft } from "react-icons/fi";

export default function Button({ label, ...props }) {
  return (
    <StyledButton {...props}>
      <span>
        <FormattedMessage id={label} />
      </span>
    </StyledButton>
  );
}

export function Return({
  previousStep,
  awaitingAIBasedImageGeneration = false,
}) {
  return (
    <ReturnButton
      disabled={awaitingAIBasedImageGeneration}
      role="button"
      onClick={previousStep}
    >
      <FiArrowLeft size={20} />
      <p>
        <FormattedMessage id={"return"} />
      </p>
    </ReturnButton>
  );
}
